import React from 'react';
import { View } from 'react-native';

import { createMqStyles } from '@fhs/ui';
import ActionButton, { ActionButtonSizes } from '@fhs-legacy/frontend/src/components/action-button';
import { useIsDesktopBp } from '@fhs-legacy/frontend/src/hooks/breakpoints';

interface SearchThisAreaButtonProps {
  onPress: () => void;
}

/**
 * Offers a fresh search around wherever the guest has moved the map to.
 *
 * Still the legacy `ActionButton`, at the sizes and the bottom-centre spot the flag-off map
 * puts it, so both locators keep the same pill.
 */
export const SearchThisAreaButton: React.VFC<SearchThisAreaButtonProps> = ({ onPress }) => {
  const styles = useSearchThisAreaButtonMqStyles();
  const isDesktop = useIsDesktopBp();

  return (
    // The row spans the map so the pill can centre in it, but only the pill takes touches.
    <View style={styles.container} pointerEvents="box-none">
      <ActionButton
        size={isDesktop ? ActionButtonSizes.LARGE : ActionButtonSizes.SMALL}
        onPress={onPress}
        testID="search-this-area-button"
      >
        Search this area
      </ActionButton>
    </View>
  );
};

const useSearchThisAreaButtonMqStyles = createMqStyles({
  container: {
    $base: {
      alignItems: 'center',
      bottom: 16,
      left: 0,
      position: 'absolute',
      right: 0,
    },
    $gteDesktop: {
      bottom: 32,
    },
  },
});
